import { objType }     from 'types';
import { ActionTypes } from 'actions/types';


export const initialSessionState: objType = {
  sessionDuration: 0
}

const sessionReducer = (state = initialSessionState, action: ActionTypes) => {

switch (action.type) {


case 'SET_SESSION_DURATION':
  {
    return {
        sessionDuration: action.payload
    }
  }



// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};


export { sessionReducer };
